import React from 'react';
import '../css/Contact.css';

const Contact = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="social-icons">
        <a href="isaac.naranjo.e.g@gmail.com" target="_blank" rel="noopener noreferrer" className="icon email">
          <i className="fas fa-envelope"></i>
        </a>
        <a href="https://www.linkedin.com/in/isaac-naranjo/" target="_blank" rel="noopener noreferrer" className="icon">
          <i className="fab fa-linkedin"></i>
        </a>
        <a href="https://www.facebook.com/isaac.naranjo" target="_blank" rel="noopener noreferrer" className="icon">
          <i className="fab fa-facebook"></i>
        </a>
        <a href="https://github.com/Arcadiastyx" target="_blank" rel="noopener noreferrer" className="icon">
          <i className="fab fa-github"></i>
        </a>
      </div>
    </section>
  );
};

export default Contact;
